import type { ClosedBehavior } from '../domain/types.js';

/** Convert snake_case / kebab enum tokens to sentence-case labels for UI. */
export function displayLabel(raw: string): string {
  const normalized = raw.replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  if (!normalized) return normalized;
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function traitOptionLabel(traitKey: string, category: string): string {
  return `${displayLabel(category)}: ${displayLabel(traitKey)}`;
}

export const CLOSED_BEHAVIOR_OPTIONS: ReadonlyArray<{ value: ClosedBehavior; label: string }> = [
  { value: 'leave', label: 'Leave the location' },
  { value: 'sleep', label: 'Sleep at the location' },
  { value: 'observable', label: 'Remain on site (observable)' },
];

export function closedBehaviorLabel(value: ClosedBehavior): string {
  return CLOSED_BEHAVIOR_OPTIONS.find((o) => o.value === value)?.label ?? displayLabel(value);
}
